import React from 'react';
import TrajeRentalSystem from './components/TrajeRentalSystem';

function App() {
  return (
    <div>
      <TrajeRentalSystem />
    </div>
  );
}

export default App;
